<template>
  <div class="sby-fee-bill-panel">
    <sby-fee-panel
      :title="title"
      :fees="currentSelectedBills()"
      :value="bills.length > 1 ? '更多' : ''"
      :link="bills.length > 1"
      @click="showSelectMonth=bills.length > 1"
    ></sby-fee-panel>
    <van-popup
      v-model="showSelectMonth"
      position="bottom"
      class="sby-fee-bill-popup"
      get-container=".page-wrap"
    >
      <div class="van-bill-picker">
        <div class="van-hairline--top-bottom van-picker__toolbar">
          <div class="van-picker__cancel" @click="showSelectMonth=false">取消</div>
          <div class="van-picker__confirm" @click="confirmSelectMonth">确认</div>
        </div>
        <van-checkbox-group v-model="selectedBillIds">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in selectMonths"
              clickable
              :key="item.id"
              @click="toggle($event, item, index)"
            >
              <template slot="title">
                <span class="custom-text">{{item.text}}</span>
                <van-tag
                  class="margin-left-5"
                  plain
                  type="danger"
                  v-bind:class="'status-' + item.bill.pay_state "
                >{{item.bill.defined ? item.bill.pay_state_desc : '基数待更新'}}</van-tag>
              </template>
              <van-checkbox :disabled="item.disabled" :name="item.bill.id" ref="checkboxes"/>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <!-- <van-picker
        show-toolbar
        :columns="selectMonths"
        @confirm="confirmSelectMonth"
        @cancel="showSelectMonth = false"
      />-->
    </van-popup>
  </div>
</template>

<script>
import _ from "lodash";
import {
  Toast,
  version,
  Dialog,
  Tag,
  Popup,
  Picker,
  Checkbox,
  Cell,
  CheckboxGroup,
  CellGroup
} from "vant";
import moment from "moment";

import {
  PaymentWayList,
  CensusTypeList,
  PaymentItemEx,
  PaymentItemExList,
  PaymentWay,
  PaymentTerm,
  PaymentPaybackItemExList,
  PaymentTermList
} from "../pages/util/state_desc";

export default {
  name: "sby-fee-bill-panel",

  components: {
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell
  },
  props: {
    bills: {
      type: Array,
      default: []
    },
    order: {
      type: Object
    },
    current: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      currentBills: [],
      showSelectMonth: false,
      selectMonths: [],
      selectedBillIds: []
    };
  },
  computed: {
    currentMonth() {
      return moment().format("YYYY-MM");
    }
  },
  mounted() {
    this.initCurrentBills();
    let months = [];
    if (this.bills.length > 1) {
      for (let bill of this.bills) {
        months.push({
          text: `${bill.months.join(",")} (第 ${bill.periods}/${
            this.bills.length
          } 期) `,
          disabled: !bill.defined || bill.pay_state !== "pending" || bill.current,
          bill: bill
        });
      }
      this.selectMonths = months;
    }
  },
  watch: {},
  methods: {
    initCurrentBills() {
      let selectedStatus = ['paid', 'audit', 'fail', 'refund']
      for (let bill of this.bills) {
        if (bill.current || selectedStatus.includes(bill.pay_state)){
          this.currentBills.push(bill);
          this.selectedBillIds.push(bill.id);
        }
      }
      this.$emit("change", this.selectedBillIds);
    },

    toggle(event, item, index) {
      if (item.disabled) {
        return;
      }
      this.$refs.checkboxes[index].toggle();
    },
    checkJumpSelect() {
      let len = this.$refs.checkboxes.length;
      let foundChecked = false;
      for (let i = len - 1; i >= 0; i--) {
        let curChecked = this.$refs.checkboxes[i].checked;
        if (curChecked) {
          foundChecked = true;
        }
        if (foundChecked && !curChecked) {
          return true;
        }
      }
      return false;
    },
    confirmSelectMonth() {
      if (this.checkJumpSelect()) {
        Toast("不支持选择非连续账单，请重新选择");
        return;
      }
      this.showSelectMonth = false;
      let curBills = [];
      for (let bill of this.bills) {
        if (this.selectedBillIds.includes(bill.id)) {
          curBills.push(bill)
        }
      }
      this.currentBills = curBills;
      this.$emit("change", this.selectedBillIds);
    },
    monthBillTitle(bill) {
      if (this.order && this.order.payment_way === "payback") {
        return `账单月份 ${bill.months[0]} 至 ${
          bill.months[bill.months.length - 1]
        }`;
      } else {
        return `${bill.months[0]}账单(第${bill.periods}/${
          this.bills.length
        }期)`;
      }
    },
    currentSelectedBills() {
      let selectedBills = [];
      for (let bill of this.currentBills) {
        selectedBills.push({
          status: {
            stat: bill.pay_state,
            text: bill.pay_state_desc
          },
          title: this.monthBillTitle(bill),
          items: this.billFeeItems(bill),
          total: bill.fee
        });
      }
      return selectedBills;
    },
    billFeeItems(bill) {
      const fees = [];
      let shebaoItemKey = "shebao";
      if (bill.payment_items.includes(shebaoItemKey) && !_.isEmpty(bill.item_shebao)) {
        fees.push({
          key: shebaoItemKey,
          title: PaymentItemEx[shebaoItemKey],
          value: bill.item_shebao.shebao_amt,
          items: bill.item_shebao.items
        });
        fees.push({
          key: shebaoItemKey,
          title: '残保金',
          value: bill.item_shebao.disability_amt,
          items: []
        });
        if (bill.item_shebao.pre_amt) {
            fees.push({
          key: shebaoItemKey,
          title: '社保涨幅预收款',
          value: bill.item_shebao.pre_amt,
          items: []
        });
        }
        
      }
      let gongjijinItemKey = "gongjijin";
      if (bill.payment_items.includes(gongjijinItemKey) && !_.isEmpty(bill.item_gongjijin)) {
        fees.push({
          key: gongjijinItemKey,
          title: PaymentItemEx[gongjijinItemKey],
          value: bill.item_gongjijin.gongjijin_amt,
          items: bill.item_gongjijin.items

        });
      }
      let salaryItemKey = "salary";
      if (bill.payment_items.includes(salaryItemKey) && !_.isEmpty(bill.item_salary)) {
        fees.push({
          key: salaryItemKey,
          title: "税后工资",
          value: bill.item_salary.salary_after_tax,
          items: [
           { name: '税前工资', amt: bill.item_salary.salary},
          ] 
        });
        if (bill.item_salary.location_bank_fee > 0) {
          fees.push({
          key: shebaoItemKey,
          title: '跨行转账手续费',
          value: bill.item_salary.location_bank_fee,
          items: []
        });

        }

      }
      let taxItemKey = "tax";
      if (bill.payment_items.includes(taxItemKey) && !_.isEmpty(bill.item_tax)) {
        fees.push({
          key: taxItemKey,
          title: PaymentItemEx[taxItemKey],
          value: bill.item_tax.tax_amt,
          items: bill.item_tax.items 
        });
        if (bill.item_tax.disability_amt > 0) {
          fees.push({
            key: "tax_disability",
            title: "残保金",
            value: bill.item_tax.disability_amt,
            
          });
        }
        if (bill.item_tax.service_tax && bill.item_tax.service_tax > 0) {
          fees.push({
            key: "service_tax",
            title: "税后劳务报酬",
            value: bill.item_tax.service_tax
          });
        }

         if (bill.item_tax.location_bank_fee && bill.item_tax.location_bank_fee > 0) {
          fees.push({
            key: shebaoItemKey,
            title: '银行手续费',
            value: bill.item_tax.location_bank_fee,
            items: []
          });
         }
        
      }

      let ztaxItemKey = "ztax";
      if (bill.payment_items.includes(ztaxItemKey) && !_.isEmpty(bill.item_ztax)) {
        fees.push({
          key: ztaxItemKey,
          title: PaymentItemEx[ztaxItemKey],
          value: 0,
          items: bill.item_ztax.items,

        });
      }
      return fees;
    }
  }
};
</script>
<style lang="less" scoped>
.van-bill-picker {
  overflow: hidden;
  position: relative;
  background-color: #fff;
  .van-cell__title {
    font-size: 14px;
    color: #323233;
    flex: 4;
  }
}
.van-checkbox-group {
  height: 270px;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow: auto;
}
.fee-panel {
  .fee-title {
    .van-cell__title {
      font-size: 14px;
    }

    padding: 5px 15px 0px 15px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sby-fee-bill-panel.vue